import React, { useState } from 'react';
import { Box, Flex, Link } from '@chakra-ui/react';
import { QuestionPage, QuestionPageProps } from './QuestionPage';
import theLogo from '../images/the-logo.png';
import topLineSvg from '#core/SdgQuiz/images/top-line.svg';
import { InfoPage, InfoPageProps } from './InfoPage';
import { FinishPage, FinishPageProps } from './FinishPage';
import { extractSdgs, useResponsive } from '../utils';
import contentJson from '../utils/content.json';

const content: any = contentJson;

export type FormData = {
  results_very_relevant?: string;
  results_partly_relevant?: string;
  results_not_very_relevant?: string;
  results_skipped?: string;
};

const SdgQuiz = () => {
  const sdgs: string[] = extractSdgs(content);

  const [pageIndex, setPageIndex] = useState(0);
  const pages = [
    { name: 'InfoPage', component: InfoPage },
    ...sdgs,
    { name: 'FinishPage', component: FinishPage },
  ];

  const isMobileScreen = useResponsive();

  const [data, setData] = useState({});

  const handleNext = () => {
    setPageIndex((index) => Math.min(index + 1, pages.length - 1));
    window.scrollTo(0, 0);
  };

  const handleBack = () => {
    setPageIndex((index) => Math.max(index - 1, 0));
    window.scrollTo(0, 0);
  };

  const updateFields = (incomingData: any, reset = false) => {
    setData((prev: any) =>
      reset ? incomingData : { ...prev, ...incomingData },
    );
  };

  const sdgNumber =
    typeof pages[pageIndex] === 'string' ? Number(pages[pageIndex]) : 0;

  const isNonSdgPage = typeof pages[pageIndex] === 'object'; // valid for InfoPage and FinishPage

  let CurrentPageComponent;
  let currentPageProps = {};

  if (!isNonSdgPage) {
    CurrentPageComponent = QuestionPage;
    currentPageProps = {
      sdgNumber,
      data,
      updateFields,
      handleNext,
      handleBack,
    } as QuestionPageProps;
  } else if ((pages[pageIndex] as { name: string }).name === 'InfoPage') {
    CurrentPageComponent = InfoPage;
    currentPageProps = {
      handleNext,
    } as InfoPageProps;
  } else {
    CurrentPageComponent = FinishPage;
    currentPageProps = {
      data,
      updateFields,
    } as FinishPageProps;
  }

  const currentContent = content[`sdg${sdgNumber}`];

  return (
    <Flex direction="column" bgColor="#F9F9F9">
      <Box
        bgImage={`url('${topLineSvg}')`}
        bgPosition="center"
        bgSize="cover"
        bgRepeat="no-repeat"
        w="100%"
        h="8px"
        minW="100%"
        position="absolute"
        top={0}
        left={0}
      />

      <Flex flex="1" justifyContent="space-between" px={5} mt={10}>
        <Box
          bgImage={`url('${theLogo}')`}
          bgPosition="left"
          bgSize="contain"
          bgRepeat="no-repeat"
          w={isMobileScreen ? '10rem' : '15rem'}
        />

        <Link
          my={isMobileScreen ? 4 : 7}
          fontSize={isMobileScreen ? 'xs' : 'md'}
          textDecoration="underline"
          fontWeight="bold"
          target="_blank"
          href={
            sdgNumber > 0
              ? currentContent.aboutLink
              : 'https://www.timeshighereducation.com/world-university-rankings/impact-rankings-2025-methodology'
          }
        >
          {sdgNumber > 0 ? content.aboutLinkSdgs : content.startPage.aboutLink}
        </Link>
      </Flex>

      <Flex
        position="relative"
        background="#F9F9F9"
        paddingTop="2rem"
        mx="1rem"
        borderRadius=".5rem"
        justifyContent="center"
        alignItems="center"
      >
        <Flex w="100%" flexDirection="column" alignItems="center">
          <Flex position="absolute" top=".5rem" right=".5rem">
            {pageIndex + 1} / {pages.length}
          </Flex>
          <CurrentPageComponent {...currentPageProps} />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default SdgQuiz;
